<template>
  <el-dialog
    title="房源详情"
    :visible.sync="dialogVisible"
    width="1000px"
    :close-on-click-modal="false"
    @close="handleClose"
    class="house-detail-dialog"
  >
    <el-tabs v-model="activeTab" type="border-card">
      <!-- 1. 基础信息 -->
      <el-tab-pane label="基础信息" name="base">
        <el-descriptions :column="2" border size="medium" v-loading="loading">
          <el-descriptions-item label="产权证地址" :span="2">
            {{ detailData.产权证地址 || '-' }}
          </el-descriptions-item>

          <el-descriptions-item label="不动产权号">
            {{ detailData.不动产权号 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="丘权号">
            {{ detailData.丘权号 || '-' }}
          </el-descriptions-item>

          <el-descriptions-item label="行政区" :span="1">
            {{ detailData.行政区 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="业务状态" :span="1">
            <el-tag :type="getBusinessStatusType(detailData.业务状态)" size="small">
              {{ detailData.业务状态 || '-' }}
            </el-tag>
          </el-descriptions-item>

          <el-descriptions-item label="出房指导价">
            {{ detailData.出房指导价 ? `¥${detailData.出房指导价}` : '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="收房指导价">
            {{ detailData.收房指导价 ? `¥${detailData.收房指导价}` : '-' }}
          </el-descriptions-item>

          <el-descriptions-item label="收房人">
            {{ detailData.收房人 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="收房门店">
            {{ detailData.收房门店 || '-' }}
          </el-descriptions-item>

          <el-descriptions-item label="室">
            {{ detailData.室 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="厅">
            {{ detailData.厅 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="卫">
            {{ detailData.卫 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="面积（平米）">
            {{ detailData['面积（平米）'] || '-' }}
          </el-descriptions-item>

          <el-descriptions-item label="楼层信息" :span="2">
            <div style="display: flex; gap: 30px;">
              <span>第{{ detailData['楼层信息（第X层）'] || '-' }}层</span>
              <span>共{{ detailData['楼层信息（共X层）'] || '-' }}层</span>
            </div>
          </el-descriptions-item>

          <el-descriptions-item label="用途" :span="2">
            {{ detailData.用途 || '-' }}
          </el-descriptions-item>

          <el-descriptions-item label="朝向" :span="2">
            {{ detailData.朝向 || '-' }}
          </el-descriptions-item>

          <el-descriptions-item label="水卡">
            {{ detailData.水卡 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="气卡">
            {{ detailData.气卡 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="电卡">
            {{ detailData.电卡 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="电卡用户名">
            {{ detailData.电卡用户名 || '-' }}
          </el-descriptions-item>

          <el-descriptions-item label="其他卡" :span="2">
            {{ detailData.其他卡 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="钥匙/密码" :span="2">
            {{ detailData['钥匙/密码'] || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">
            {{ detailData.备注 || '-' }}
          </el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>

      <!-- 2. 收房详情 -->
      <el-tab-pane label="收房详情" name="receive">
        <el-descriptions :column="2" border size="medium" v-loading="loading">
          <el-descriptions-item label="产权人" :span="2">
            {{ detailData.房东姓名 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="产权人电话">
            {{ detailData.房东电话 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="产权人身份证号">
            {{ detailData.产权人身份证号 || '-' }}
          </el-descriptions-item>

          <el-descriptions-item label="受托代理人姓名">
            {{ detailData.受托代理人姓名 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="委托人电话">
            {{ detailData.委托人电话 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="送达地址" :span="1">
            {{ detailData.送达地址 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="合同编号" :span="1">
            {{ detailData.合同编号 || '-' }}
          </el-descriptions-item>

          <el-descriptions-item label="收房渠道">
            {{ detailData.收房渠道 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="收房费用">
            {{ detailData.收房费用 ? `¥${detailData.收房费用}` : '-' }}
          </el-descriptions-item>

          <el-descriptions-item label="合同起始日">
            {{ formatTimestamp(detailData.合同起始日) }}
          </el-descriptions-item>
          <el-descriptions-item label="合同到期日">
            {{ formatTimestamp(detailData.合同到期日) }}
          </el-descriptions-item>

          <el-descriptions-item label="第一年免租期（天）">
            {{ detailData['第一年免租期（天）'] || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="第二年免租期（天）">
            {{ detailData['第二年免租期（天）'] || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="第三年免租期（天）">
            {{ detailData['第三年免租期（天）'] || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="免租期备注">
            {{ detailData.免租期备注 || '-' }}
          </el-descriptions-item>

          <el-descriptions-item label="押金">
            {{ detailData.押金 ? `¥${detailData.押金}` : '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="收房租金（元/月）">
            {{ detailData['收房租金（元/月）'] ? `¥${detailData['收房租金（元/月）']}` : '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="支付周期" :span="2">
            {{ detailData.支付周期 || '-' }}
          </el-descriptions-item>

          <el-descriptions-item label="特别约定" :span="2">
            {{ detailData.特别约定 || '-' }}
          </el-descriptions-item>

          <el-descriptions-item label="支付户名">
            {{ detailData.支付户名 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="银行卡号">
            {{ detailData.银行卡号 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="开户行" :span="2">
            {{ detailData.开户行 || '-' }}
          </el-descriptions-item>

          <el-descriptions-item label="交房日期" :span="2">
            {{ formatTimestamp(detailData.交房日期) }}
          </el-descriptions-item>
          <el-descriptions-item label="是否开通燃气" :span="2">
            {{ detailData.是否开通燃气 || '-' }}
          </el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
    </el-tabs>

    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { sqlBaseApi } from '@/api/通用/sqlBaseApi'

export default {
  name: 'HouseDetailDialog',

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    houseId: {
      type: [String, Number],
      default: null
    }
  },

  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
      detailData: {},
      activeTab: 'base'
    }
  },

  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val && this.houseId) {
        this.loadHouseData()
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },

  methods: {
   // ====== 加载房源数据 ======
async loadHouseData() {
  if (!this.houseId) {
    this.$message.warning('房源ID不存在  ')
    return
  }

  this.loading = true

  try {
    const params = {
      tableName: '房源',
      conditions: [
        {
          field: 'id',
          type: 'INTEGER',        // 类型改为 INTEGER
          operator: 'EQ',
          value: Number(this.houseId)  // 转为数字
        }
      ],
      pageIndex: 1,
      pageSize: 1
    }

    console.log('查询房源参数===', params)
     console.log('查询房源参数--id===', params.conditions[0].value)

    const res = await sqlBaseApi.query(params)
    console.log('查询房源返回===', res)
 
    if (res.code === 200) {
      const list = res.data?.list || []
      if (list.length > 0) { 
        this.detailData = this.mapFields(list[0])
      } else {
        this.$message.warning('未找到该房源信息')
      }
    } else {
      this.$message.error(res.message || '查询房源失败')
    }
  } catch (error) {
    console.error('查询房源失败:', error)
    this.$message.error(error.message || '查询房源失败，请稍后重试')
  } finally {
    this.loading = false
  }
},

    mapFields(data) {
      if (!data) return {}

      const fieldMap = {
        'id': 'id',
        '行政区': '行政区',
        '房屋地址': '房屋地址',
        '面积（平米）': '面积（平米）',
        '室': '室',
        '厅': '厅',
        '卫': '卫',
        '收房费用': '收房费用',
        '收房指导价': '收房指导价',
        '收房渠道': '收房渠道',
        '合同起始日': '合同起始日',
        '合同到期日': '合同到期日',
        '收房人': '收房人',
        '合同编号': '合同编号',
        '收房门店': '收房门店',
        '业务状态': '业务状态',
        '出房指导价': '出房指导价',
        '楼层信息（第X层）': '楼层信息（第X层）',
        '楼层信息（共X层）': '楼层信息（共X层）',
        '用途': '用途',
        '朝向': '朝向',
        '是否开通燃气': '是否开通燃气',
        '水卡': '水卡',
        '电卡用户名': '电卡用户名',
        '电卡': '电卡',
        '气卡': '气卡',
        '其他卡': '其他卡',
        '钥匙/密码': '钥匙/密码',
        '备注': '备注',
        '产权证地址': '产权证地址',
        '不动产权号': '不动产权号',
        '丘权号': '丘权号',
        '房东姓名': '房东姓名',
        '房东电话': '房东电话',
        '产权人身份证号': '产权人身份证号',
        '受托代理人姓名': '受托代理人姓名',
        '委托人电话': '委托人电话',
        '送达地址': '送达地址',
        '押金': '押金',
        '收房租金（元/月）': '收房租金（元/月）',
        '支付周期': '支付周期',
        '特别约定': '特别约定',
        '支付户名': '支付户名',
        '银行卡号': '银行卡号',
        '开户行': '开户行',
        '第一年免租期（天）': '第一年免租期（天）',
        '第二年免租期（天）': '第二年免租期（天）',
        '第三年免租期（天）': '第三年免租期（天）',
        '免租期备注': '免租期备注',
        '交房日期': '交房日期'
      }

      const result = {}
      for (const [backendKey, frontendKey] of Object.entries(fieldMap)) {
        if (data.hasOwnProperty(backendKey)) {
          result[frontendKey] = data[backendKey]
        }
      }

      // 时间戳转为毫秒级
      const timestampFields = ['合同起始日', '合同到期日', '交房日期']
      timestampFields.forEach(field => {
        if (result[field] !== undefined && result[field] !== null && result[field] !== '') {
          const str = String(result[field])
          if (str.length === 10) {
            result[field] = result[field] * 1000
          }
        }
      })

      return result
    },

    getBusinessStatusType(status) {
      const map = {
        '待出租': 'success',
        '已出租': 'warning',
        '已到期': 'info',
        '已中止': 'danger',
        '装修中': 'primary',
        '其他': 'info'
      }
      return map[status] || 'info'
    },

    formatTimestamp(timestamp) {
      if (!timestamp) return '-'
      let ts = timestamp
      const str = String(ts)
      if (str.length === 10) {
        ts = ts * 1000
      }
      const date = new Date(ts)
      if (isNaN(date.getTime())) {
        return '-'
      }
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.house-detail-dialog /deep/ .el-dialog {
  max-height: 92vh;
  display: flex;
  flex-direction: column;
}

.house-detail-dialog /deep/ .el-dialog__body {
  flex: 1;
  overflow: hidden;
  padding: 20px 20px 10px 20px;
}

.house-detail-dialog /deep/ .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding: 12px 20px;
}

.house-detail-dialog .el-tabs {
  margin-top: 0;
}

.house-detail-dialog .el-tabs__content {
  padding: 20px;
  max-height: 500px;
  overflow-y: auto;
}
</style>